import { YOO_FINDS_CDN } from "@/common";
import { IconMenu, IconShoppingBag } from "@/components/Icons";

export const AUTHORIZED_STEPS = [
  {
    src: `${YOO_FINDS_CDN}/h5/authorized-address/step-1.webp`,
    title: "Step-1",
    desc: "Click the button below ' Authorize Now ' to go to TikTok.",
  },
  {
    src: `${YOO_FINDS_CDN}/h5/authorized-address/step-2.webp`,
    title: "Step-2",
    desc: (
      <>
        1. Click “profile”; 2. Click &apos;
        <IconShoppingBag />
        &apos; icon; 3. Click &apos;TikTok Shop Creator Center&apos;.
      </>
    ),
  },
  {
    src: `${YOO_FINDS_CDN}/h5/authorized-address/step-3.webp`,
    title: "Step-3",
    desc: (
      <>
        Click on the &apos;
        <IconMenu />
        &apos; in the upper right corner.
      </>
    ),
  },
  {
    src: `${YOO_FINDS_CDN}/h5/authorized-address/step-4.webp`,
    title: "Step-4",
    desc: `Click to enter the "Partnerships".`,
  },
  {
    src: `${YOO_FINDS_CDN}/h5/authorized-address/step-5.webp`,
    title: "Step-5",
    desc: `Click to enter the "Sample authorization request" from OMUMU.`,
  },
  {
    src: `${YOO_FINDS_CDN}/h5/authorized-address/step-6.webp`,
    title: "Step-6",
    desc: "Please ensure that the shipping address is correct.",
  },
];
